import { saveFile } from 'src/utils/pdfUtil';

const downloadPdf = (data, docTitle) => {

  let fileName = `${docTitle}_document.pdf`;

  saveFile({ data }, fileName);
};

export default downloadPdf;
